import { State } from "../types";

export interface ImportResult {
  success: boolean;
  data?: State;
  error?: string;
}

export const validateImportData = (data: any): data is State => {
  if (!data || typeof data !== 'object' || data === null) {
    return false;
  }

  return (
    Array.isArray(data.habits) &&
    Array.isArray(data.days) &&
    typeof data.sortOrder === "string" &&
    (data.sortOrder === "alphabetical" || data.sortOrder === "score")
  );
};

export const parseImportFile = async (file: File): Promise<ImportResult> => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      try {
        const data = JSON.parse(reader.result as string);

        if (validateImportData(data)) {
          resolve({
            success: true,
            data: data as State,
          });
        } else {
          resolve({
            success: false,
            error: "Invalid data format. Please ensure the file contains valid habit tracker data.",
          });
        }
      } catch (error) {
        resolve({
          success: false,
          error: "Failed to parse JSON file. Please ensure the file is a valid JSON format.",
        });
      }
    };

    reader.onerror = () => {
      resolve({
        success: false,
        error: "Failed to access file. Please try again.",
      });
    };

    reader.readAsText(file);
  });
};

export const importDataFromFile = async (file: File): Promise<ImportResult> => {
  if (!file) {
    return {
      success: false,
      error: "No file selected.",
    };
  }

  if (!file.type.includes('json') && !file.name.endsWith('.json')) {
    return {
      success: false,
      error: "Please select a JSON file.",
    };
  }

  return await parseImportFile(file);
};